module.exports = __webpack_public_path__ + "static/img/icon-3.7a720df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-5/icon-3.png
// module id = lMS6
// module chunks = 0